// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .tarjeta-usuario{
    width: 32%;
    gap: 12px;
    border: 1px solid #007932;
    border-left: 15px solid #007932;
    border-radius: 28px;
    padding: 20px 30px 15px 20px;
  }

  .tarjeta-usuario:hover{
    text-decoration: none;
    border: 1px solid #000;
    border-left: 15px solid #000;
  } 
  .tarjeta-usuario img{
    height: 70px;
    width: 70px;  
    border-radius: 50%;
    object-fit: cover;
  }

  .tarjeta-usuario .datos{ padding-left: 5px; }  
  .tarjeta-usuario .informacion{ margin-bottom: 10px; }
  .tarjeta-usuario .informacion p{ text-transform: capitalize; }
  .tarjeta-usuario .informacion span{ font-weight: 600; }
  
  .estado {
    width: 12px; 
    height: 12px;
    border-radius: 50%;
    margin-right: 7.5px;
  }
  
  .estado.activo { background-color: #3c4a99; }
  .estado.inactivo { background-color: #8E151D; }
  .estado.aceptado { background-color: #da8d00; }
  .estado.pendiente { background-color: #da8d00; }
  
  .tarjeta-usuario .acciones{ gap: 12px; }
  
  .tarjeta-usuario .acciones a, .tarjeta-usuario .acciones button{
    padding: 0px;
    background-color: transparent;
    border: none;
  }
  
  .tarjeta-usuario .acciones svg{
    color: #007932;
    font-size: 18px;
  }
  
  .tarjeta-usuario .acciones a:hover svg, .tarjeta-usuario .acciones button:hover svg{ color: #000000; }  

.accesos-directos-tarjeta .modal-header{ padding: 15px 25px; }

.accesos-directos-tarjeta textarea{ 
  border: 1px solid black;
  border-radius: 10px;
  padding: 5px 10px;
 }

  @media (min-width: 1600px) {
    .tarjeta-usuario{ width: 23%; }
  }
  
  @media (max-width: 1220px) {
    .tarjeta-usuario{ width: 48%; }
  }`, "",{"version":3,"sources":["webpack://./src/components/css/TarjetaUsuario.css"],"names":[],"mappings":"EAAE;IACE,UAAU;IACV,SAAS;IACT,yBAAyB;IACzB,+BAA+B;IAC/B,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,4BAA4B;EAC9B;EACA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA,yBAAyB,iBAAiB,EAAE;EAC5C,+BAA+B,mBAAmB,EAAE;EACpD,iCAAiC,0BAA0B,EAAE;EAC7D,oCAAoC,gBAAgB,EAAE;;EAEtD;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA,iBAAiB,yBAAyB,EAAE;EAC5C,mBAAmB,yBAAyB,EAAE;EAC9C,mBAAmB,yBAAyB,EAAE;EAC9C,oBAAoB,yBAAyB,EAAE;;EAE/C,4BAA4B,SAAS,EAAE;;EAEvC;IACE,YAAY;IACZ,6BAA6B;IAC7B,YAAY;EACd;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA,qFAAqF,cAAc,EAAE;;AAEvG,yCAAyC,kBAAkB,EAAE;;AAE7D;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;CAClB;;EAEC;IACE,kBAAkB,UAAU,EAAE;EAChC;;EAEA;IACE,kBAAkB,UAAU,EAAE;EAChC","sourcesContent":["  .tarjeta-usuario{\n    width: 32%;\n    gap: 12px;\n    border: 1px solid #007932;\n    border-left: 15px solid #007932;\n    border-radius: 28px;\n    padding: 20px 30px 15px 20px;\n  }\n\n  .tarjeta-usuario:hover{\n    text-decoration: none;\n    border: 1px solid #000;\n    border-left: 15px solid #000;\n  } \n  .tarjeta-usuario img{\n    height: 70px;\n    width: 70px;  \n    border-radius: 50%;\n    object-fit: cover;\n  }\n\n  .tarjeta-usuario .datos{ padding-left: 5px; }  \n  .tarjeta-usuario .informacion{ margin-bottom: 10px; }\n  .tarjeta-usuario .informacion p{ text-transform: capitalize; }\n  .tarjeta-usuario .informacion span{ font-weight: 600; }\n  \n  .estado {\n    width: 12px; \n    height: 12px;\n    border-radius: 50%;\n    margin-right: 7.5px;\n  }\n  \n  .estado.activo { background-color: #3c4a99; }\n  .estado.inactivo { background-color: #8E151D; }\n  .estado.aceptado { background-color: #da8d00; }\n  .estado.pendiente { background-color: #da8d00; }\n  \n  .tarjeta-usuario .acciones{ gap: 12px; }\n  \n  .tarjeta-usuario .acciones a, .tarjeta-usuario .acciones button{\n    padding: 0px;\n    background-color: transparent;\n    border: none;\n  }\n  \n  .tarjeta-usuario .acciones svg{\n    color: #007932;\n    font-size: 18px;\n  }\n  \n  .tarjeta-usuario .acciones a:hover svg, .tarjeta-usuario .acciones button:hover svg{ color: #000000; }  \n\n.accesos-directos-tarjeta .modal-header{ padding: 15px 25px; }\n\n.accesos-directos-tarjeta textarea{ \n  border: 1px solid black;\n  border-radius: 10px;\n  padding: 5px 10px;\n }\n\n  @media (min-width: 1600px) {\n    .tarjeta-usuario{ width: 23%; }\n  }\n  \n  @media (max-width: 1220px) {\n    .tarjeta-usuario{ width: 48%; }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
